import { Response } from '../../utils/interfaces';
import { NivelDTO } from '../../utils/models';
import http from '../http/http';

export class NivelService {
  getAllNivels() {
    return http.get<Response<NivelDTO[]>>('/Nivel');
  }
  getAllLevels() {
    return http.get<Response<NivelDTO[]>>('/Nivel/Niveles');
  }
}
